import { useCallback, useState } from "react";
import { useSession } from "../net/SessionContext";
import type { CommandResult, GameCommand } from "../protocol";
import { useGame } from "../state/store";

const NONE: readonly string[] = [];

/** Send a command; shows the server's reason as a toast when it is rejected, unless the screen
 * shows that reason itself: `inline` lists the engine codes it handles (keep it a constant). */
export function useCommand(inline: readonly string[] = NONE) {
  const session = useSession();
  const showToast = useGame((s) => s.showToast);
  const [busy, setBusy] = useState(false);

  const run = useCallback(
    async (cmd: GameCommand): Promise<CommandResult> => {
      setBusy(true);
      try {
        const result = await session.send(cmd);
        const shown = result.kind === "error" && inline.includes(result.engine_code ?? "");
        if (result.kind === "error" && !shown) showToast(result.message, "error");
        return result;
      } finally {
        setBusy(false);
      }
    },
    [session, showToast, inline],
  );

  return { run, busy };
}
